module.exports = __webpack_public_path__ + "img/intensive-fan.84b63c24.png";